import z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export enum ProcurementState {
  OPEN = "open",
  IN_REVIEW = "inReview",
  CLOSED = "closed",
  CANCELED = "canceled",
}

export const procurementStateTimeline: ProcurementState[] = [
  ProcurementState.OPEN,
  ProcurementState.IN_REVIEW,
  ProcurementState.CLOSED,
];

export function canCancelProcurement(state: ProcurementState): boolean {
  return (
    state === ProcurementState.OPEN || state === ProcurementState.IN_REVIEW
  );
}

export function requiresWinnerSelection(
  state: ProcurementState,
  organizationCount: number,
): boolean {
  return (
    state === ProcurementState.IN_REVIEW &&
    organizationCount > 0
  );
}

export function getProcurementStateTimelineIndex(
  state: ProcurementState,
): number {
  return procurementStateTimeline.indexOf(state);
}

export function getAdjacentProcurementState(
  state: ProcurementState,
  direction: "next" | "previous",
): ProcurementState | undefined {
  const index = getProcurementStateTimelineIndex(state);
  if (index === -1) {
    return undefined;
  }
  const adjacentIndex = direction === "next" ? index + 1 : index - 1;
  return procurementStateTimeline[adjacentIndex];
}

export const procurementSchema = surrealRecordSchema.extend({
  title: z.string(),
  description: z.string().optional(),
  tags: z.array(z.string()),
  state: z.nativeEnum(ProcurementState),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Procurement = z.infer<typeof procurementSchema>;

export function isProcurementLockedForEdits(state: ProcurementState): boolean {
  return state === ProcurementState.IN_REVIEW;
}

export function isProcurementFilesReadOnly(state: ProcurementState): boolean {
  return state !== ProcurementState.OPEN;
}

export function hasProcurementContentChanges(update: {
  title?: unknown;
  description?: unknown;
  tags?: unknown;
  organizations?: unknown;
  winnerId?: unknown;
  contractId?: unknown;
  state?: unknown;
}): boolean {
  return (
    update.title !== undefined ||
    update.description !== undefined ||
    update.tags !== undefined ||
    update.organizations !== undefined
  );
}
